import { useEffect, useRef, useState } from "react";
import TabSelector from "../JobPost/TabSelector";
import Input from "../JobPost/input";
import Experience from "../JobPost/experience";
import Select from "../JobPost/Select";
import Skills from "../JobPost/Skills";
import TextArea from "../JobPost/TextArea";
import { PrimaryButton } from "../reusble_components/buttons/primaryButton";
import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import Mcq from "./mcq";
import Technical from "./technical";
import HrInterview from "./hrInterview";
import JobOverview from "./jobPreview/mainPage";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import HelpCenter from "../reusble_components/helpCenter";
import Loader from "../reusble_components/loader";
import { toJS } from "mobx";
import Pay from "../JobPost/Pay";
import PercentageInput from "../JobPost/PercentageInput";
import InterviewSettings from "../interview/InterviewSetting";
import { AiOutlineLeft } from "react-icons/ai";
import Jobpostcancelepopup from "./jobpostcancelpopup";
import Task from "./Task";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { SearchableSelect } from "../UI/searchable-select";
import { SKILL_OPTIONS } from "../../helpers/constantVariables";
import { CITY_OPTIONS } from "../../helpers/constantVariables";
import { QUALIFICATION_OPTIONS } from "../../helpers/constantVariables";
import {
  MdOutlineAutoAwesome,
  MdOutlineCode,
  MdOutlineBusinessCenter,
} from "react-icons/md";
import Prescreening from "./Prescreening";
// import OtherPlatforms from "./OtherPlatforms";

export default function JobPost() {
  const closeModal = () => setOpen(false);
  const [open, setOpen] = useState(false);
  const { CommonStore, RecuiterStore } = useStores();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const isEdit = searchParams.get("isEdit");
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchjobPost = async () => {
      await RecuiterStore.fetchJobPostDetails(id);
      setLoading(false);
    };
    if (isEdit) {
      fetchjobPost();
    } else {
      setLoading(false);
    }
    return () => {
      // Only reset store state if the store is properly initialized
      if (CommonStore && CommonStore.label) {
        try {
          CommonStore.setLabelSkipped(1, false);
          CommonStore.setLabelSkipped(2, false);
          CommonStore.setLabelSkipped(3, false);
          CommonStore.setLabelSkipped(4, false);
          CommonStore.setLabelSkipped(5, false);
          CommonStore.setLabelSkipped(6, false);
          CommonStore.setLabelSkipped(7, false);
          CommonStore.setLabelActive(1, false);
          CommonStore.setLabelActive(2, false);
          CommonStore.setLabelActive(3, false);
          CommonStore.setLabelActive(4, false);
          CommonStore.setLabelActive(5, false);
          CommonStore.setLabelActive(6, false);
          CommonStore.setLabelActive(7, false);
        } catch (error) {
          console.warn("Error during store cleanup:", error);
        }
      }
    };
  }, [location, isEdit, id]);

  return useObserver(() => (
    <div className="w-full mt-3">
      <HelpCenter />
      <Loader loader={loading} />
      <div className="flex justify-center">
        <div
          className={`flex items-center w-[90%] md:ml-0 lg:ml-0 ml-[15rem] mx-auto ${
            isEdit ? "justify-center" : "justify-between"
          } `}
        >
          {!isEdit && <p className="md:block lg:block hidden"></p>}
          <p className="text-xl font-semibold text-primary text-center justify-center md:block lg:block hidden md:pl-[7%] lg:pl-[7%] pl-0">
            {isEdit ? "Edit Job post" : "Create new job post"}
          </p>
          {!isEdit && (
            <button
              onClick={() => {
                setOpen(true);
              }}
              className="sm:text-sm tc1:text-xs border-[#DEDEDE] border sm:px-4 sm:py-2 tc1:px-1 tc1:py-1 rounded-full bg-white tc1:mt-4 sm:mt-0"
            >
              Cancel job post
            </button>
          )}
        </div>
      </div>
      <Jobpostcancelepopup
        popUpInitialValue={open}
        content=" Do you want to cancel the Job Post"
        closeThisPopUP={() => setOpen(false)}
        buttontext="Sure"
        onClick={() => {
          isEdit
            ? navigate("/company/activity")
            : navigate("/company/services");
          // Reset job post data when canceling
          RecuiterStore.resetJobPostData();
          // Reset common store progress and labels
          CommonStore.setLabelActive(1, false);
          CommonStore.setLabelActive(2, false);
          CommonStore.setLabelActive(3, false);
          CommonStore.setLabelActive(4, false);
          CommonStore.setLabelActive(5, false);
          CommonStore.setLabelActive(6, false);
          CommonStore.setLabelActive(7, false);
          CommonStore.setProgress(0);
        }}
        onClose={() => setOpen(false)}
      ></Jobpostcancelepopup>
      <p className="text-lg font-bold text-primary sm:text-center md:hidden lg:hidden block tc1:-mt-7 tc1:text-start tc1:pl-5">
        {isEdit ? "Edit Job post" : "Create a new job post"}
      </p>
      <div className="w-[95%] mx-auto py-1 border-b mb-2 md:mb-0 lg:mb-0 border-[#8E8E8E] tc1:overflow-x-auto tc1:overflow-y-hidden tc1:no-scrollbar">
        <div className="w-full mx-auto">
          <TabSelector isEdit={isEdit} />
        </div>
      </div>
      {CommonStore.progress === 0 && !loading && (
        <JobPostForm isEdit={isEdit} />
      )}
      {CommonStore.progress === 1 && <Prescreening isEdit={isEdit} />}
      {CommonStore.progress === 2 && <Mcq isEdit={isEdit} addMT={true} />}
      {CommonStore.progress === 3 && <Technical isEdit={isEdit} />}
      {CommonStore.progress === 4 && <HrInterview isEdit={isEdit} />}
      {CommonStore.progress === 5 && <Task isEdit={isEdit} />}
      {CommonStore.progress === 6 && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (
              RecuiterStore.jobPostDetails.customSettings.find(
                (setting) => setting.name === "aiVoice",
              )?.value === ""
            ) {
              alert("Please select an AI voice");
              return;
            }
            CommonStore.setProgress(7);
            CommonStore.setLabelActive(6, true);
          }}
          className="pb-20"
        >
          <InterviewSettings />

          <div className="flex w-[94%] md:w-[94%]  lg:w-[91%] mx-auto justify-between items-center gap-4">
            <button
              type="button"
              className="flex items-center text-primary gap-2  lg:-ml-6 mt-2"
              onClick={() => {
                CommonStore.setProgress(5);
              }}
            >
              <AiOutlineLeft /> Back
            </button>
            <PrimaryButton
              buttonName={"Next"}
              width="w-fit"
              type={"submit"}
              padding={10}
              rounded="lg"
            />
          </div>
        </form>
      )}
      {/* {CommonStore.progress === 7 && <OtherPlatforms isEdit={isEdit} />} */}
      {CommonStore.progress === 7 && (
        <div className="md:w-[80%] lg:w-[80%] w-[95%] mx-auto">
          <JobOverview newjobpost={true} />
        </div>
      )}
    </div>
  ));
}

export function JobPostForm({ isEdit }) {
  const [temp, setTemp] = useState(null);
  const [descriptionEdited, setDescriptionEdited] = useState(false);
  const [descriptionSetting, setDescriptionSetting] = useState(false);
  const [logoUploading, setLogoUploading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const { CommonStore, RecuiterStore } = useStores();
  const logoInputRef = useRef(
    RecuiterStore.jobPostDetails.basicJobDetails.companyLogo || "",
  );
  // Initialize state with store values
  const [jobType, setJobType] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.jobType || "",
  );
  const [jobTitle, setJobTitle] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.jobTitle || "",
  );
  const [location, setLocation] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.location || [],
  );
  const [companyLogo, setCompanyLogo] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.companyLogo || "",
  );
  const [companyWebsite, setCompanyWebsite] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.companyWebsite || " ",
  );
  const [companyName, setCompanyName] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.companyName ||
      user?.companyName,
  );

  useEffect(() => {
    // if (user?.pic) {
    //   setCompanyLogo(user.pic);
    //   RecuiterStore.setBasicJobDetails("companyLogo", user.pic);
    // }
    // if (user?.companyName) {
    //   setCompanyName(user.companyName);
    //   RecuiterStore.setBasicJobDetails("companyName", user.companyName);
    // }
    console.log(RecuiterStore.jobPostDetails.basicJobDetails);
  }, []);

  const [aboutCompany, setAboutCompany] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.aboutCompany || "",
  );
  const [parttime, setPartTime] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.parttime || "",
  );
  const [responsibilities, setResponsibilities] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.responsibilities || "",
  );
  const [workMode, setWorkMode] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.workMode || "",
  );
  const [experience, setExperience] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.experience || [0, 0],
  );
  const [resumeCutoff, setResumeCutoff] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.resumeCutoff || "",
  );
  const [salary, setSalary] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.salary || [0, 0],
  );
  const [noOfOpenings, setNoOfOpenings] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.openings || "",
  );
  const [jobDescription, setJobDescription] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.jobDescription || "",
  );
  const [skills, setSkills] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills || [],
  );
  const [qualification, setQualification] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.qualification || "",
  );
  const [noticePeriod, setNoticePeriod] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.noticePeriod || "",
  );
  const [roleType, setRoleType] = useState(
    RecuiterStore.jobPostDetails.basicJobDetails.roleType || "",
  );
  const skillsDiv = useRef();

  const scrollToSkills = () => {
    skillsDiv.current.scrollIntoView();
  };

  useEffect(() => {
    setTemp(
      RecuiterStore.jobPostDetails?.basicJobDetails?.jobTitle +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.workMode +
        " " +
        (Array.isArray(RecuiterStore.jobPostDetails?.basicJobDetails?.location)
          ? RecuiterStore.jobPostDetails?.basicJobDetails?.location.join(" ")
          : RecuiterStore.jobPostDetails?.basicJobDetails?.location || "") +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.openings +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.qualification +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.noticePeriod +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.experience[0] +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.experience[1] +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.parttime +
        " " +
        skills.join(" ") +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.currency +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.rate +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.min +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.max,
    );

    // setJobType(RecuiterStore.jobPostDetails.basicJobDetails.jobType);
    setJobTitle(RecuiterStore.jobPostDetails.basicJobDetails.jobTitle ?? "");
    setLocation(
      Array.isArray(RecuiterStore.jobPostDetails.basicJobDetails.location)
        ? RecuiterStore.jobPostDetails.basicJobDetails.location
        : RecuiterStore.jobPostDetails.basicJobDetails.location
          ? [RecuiterStore.jobPostDetails.basicJobDetails.location]
          : [],
    );
    setPartTime(RecuiterStore.jobPostDetails.basicJobDetails.parttime || "");
    setResponsibilities(
      RecuiterStore.jobPostDetails.basicJobDetails.responsibilities || "",
    );
    setWorkMode(RecuiterStore.jobPostDetails.basicJobDetails.workMode || "");
    setExperience(
      RecuiterStore.jobPostDetails.basicJobDetails.experience || [0, 0],
    );
    setSalary(RecuiterStore.jobPostDetails.basicJobDetails.salary || [0, 0]);
    setNoOfOpenings(
      RecuiterStore.jobPostDetails.basicJobDetails.openings || "",
    );
    setQualification(
      RecuiterStore.jobPostDetails.basicJobDetails.qualification || "",
    );
    setNoticePeriod(
      RecuiterStore.jobPostDetails.basicJobDetails.noticePeriod || "",
    );
    setResumeCutoff(
      RecuiterStore.jobPostDetails.basicJobDetails.resumeCutoff || "",
    );
    setJobDescription(
      RecuiterStore.jobPostDetails.basicJobDetails.jobDescription || "",
    );
    setSkills(
      RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills || [],
    );
    console.log(RecuiterStore.jobPostDetails.basicJobDetails.jobTitle);
    console.log(RecuiterStore.jobPostDetails.basicJobDetails.jobDescription);
  }, [RecuiterStore.jobPostDetails.basicJobDetails]);

  const setaddedSkills = (skill) => {
    if (!skills.includes(skill) && skill !== "") setSkills([...skills, skill]);
    const requiredSkills =
      RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills;

    if (!requiredSkills.includes(skill)) {
      RecuiterStore.setBasicJobDetails("requiredSkills", [
        ...requiredSkills,
        skill,
      ]);
      RecuiterStore.setSkillsField(false);
    }
  };

  const removeaddedSkills = (index) => {
    setSkills(skills.filter((_, i) => i !== index));
    const requiredSkills =
      RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills;
    RecuiterStore.setBasicJobDetails(
      "requiredSkills",
      requiredSkills.filter((_, i) => i !== index),
    );
  };

  const setaddedLocation = (city) => {
    if (!location.includes(city) && city !== "") {
      setLocation([...location, city]);
      const locations =
        RecuiterStore.jobPostDetails.basicJobDetails.location || [];
      if (!locations.includes(city)) {
        RecuiterStore.setBasicJobDetails("location", [...locations, city]);
        setDescriptionEdited(false);
      }
    }
  };

  const removeaddedLocation = (index) => {
    setLocation(location.filter((_, i) => i !== index));
    const locations =
      RecuiterStore.jobPostDetails.basicJobDetails.location || [];
    RecuiterStore.setBasicJobDetails(
      "location",
      locations.filter((_, i) => i !== index),
    );
  };

  const handleSubmit = (e) => {
    // if (Number(salary[0]) < Number(salary[1])) {
    //   alert("Min salary should be less than max salaryy");
    //   // e.target.value = minValueRef1.current.value;
    //   return;
    // }
    e.preventDefault();

    if (
      Number(RecuiterStore.jobPostDetails.basicJobDetails.salary.min) >
        Number(RecuiterStore.jobPostDetails.basicJobDetails.salary.max) &&
      RecuiterStore.jobPostDetails.basicJobDetails.salary.showPayBy === "range"
    ) {
      return alert("Min salary should be less than max salary");
    }
    if (
      Number(RecuiterStore.jobPostDetails.basicJobDetails.experience[0]) >
      Number(RecuiterStore.jobPostDetails.basicJobDetails.experience[1])
    ) {
      return alert("Min experience should be less than max experience");
    }

    if (
      RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills.length === 0
    ) {
      RecuiterStore.setSkillsField(true);
      scrollToSkills();
      alert("Select atleast one skill");
      return;
    }
    if (
      RecuiterStore.jobPostDetails?.basicJobDetails?.jobTitle +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.workMode +
        " " +
        (Array.isArray(RecuiterStore.jobPostDetails?.basicJobDetails?.location)
          ? RecuiterStore.jobPostDetails?.basicJobDetails?.location.join(" ")
          : RecuiterStore.jobPostDetails?.basicJobDetails?.location || "") +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.openings +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.qualification +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.noticePeriod +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.experience[0] +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.experience[1] +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.parttime +
        " " +
        skills.join(" ") +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.currency +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.rate +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.min +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.max !==
        temp &&
      !isEdit &&
      !descriptionEdited
    ) {
      alert("Please click on the description field to update the description");
      console.log(temp);
      return;
    }
    console.log("jobType", jobType);
    console.log("jobTitle", jobTitle);
    console.log("workMode", workMode);
    console.log("experience", experience);
    console.log("noOfOpenings", noOfOpenings);
    console.log("jobDescription", jobDescription);
    console.log("responsibilities", responsibilities);
    console.log("location", location);
    console.log("parttime", parttime);
    console.log("salary", salary);
    console.log("skills", skills);
    // RecuiterStore.setBasicJobDetails("jobType", jobType);
    RecuiterStore.setBasicJobDetails("jobTitle", jobTitle);
    RecuiterStore.setBasicJobDetails("workMode", workMode);
    RecuiterStore.setBasicJobDetails("experience", experience);
    RecuiterStore.setBasicJobDetails("openings", noOfOpenings);
    RecuiterStore.setBasicJobDetails("jobDescription", jobDescription);
    RecuiterStore.setBasicJobDetails("responsibilities", responsibilities);
    RecuiterStore.setBasicJobDetails("location", location);
    RecuiterStore.setBasicJobDetails("parttime", parttime);
    // RecuiterStore.setBasicJobDetails("salary", salary);
    RecuiterStore.setBasicJobDetails("requiredSkills", skills);
    RecuiterStore.setBasicJobDetails("qualification", qualification);
    RecuiterStore.setBasicJobDetails("noticePeriod", noticePeriod);
    CommonStore.setProgress(1);
  };

  const handleAutoGeneration = async () => {
    if (roleType !== "technical" && roleType !== "nonTechnical") {
      alert("Please select a valid role type");
      return;
    }
    console.log(toJS(RecuiterStore.jobPostDetails.basicJobDetails), "asdfgh");
    if (
      RecuiterStore.jobPostDetails?.basicJobDetails?.jobTitle === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.jobTitle === undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.workMode === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.workMode === undefined ||
      // RecuiterStore.jobPostDetails?.basicJobDetails?.location === "" ||
      // RecuiterStore.jobPostDetails?.basicJobDetails?.location === undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.openings === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.openings === undefined ||
      // RecuiterStore.jobPostDetails?.basicJobDetails?.qualification === "" ||
      // RecuiterStore.jobPostDetails?.basicJobDetails?.qualification ===
      //   undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.noticePeriod === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.noticePeriod ===
        undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.experience[0] === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.experience[0] ===
        undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.experience[1] === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.experience[1] ===
        undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.parttime === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.parttime === undefined ||
      skills.length === 0 ||
      (RecuiterStore.jobPostDetails?.basicJobDetails?.salary
        ?.isSalaryDisclosed &&
        (RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.currency ===
          "" ||
          RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.currency ===
            undefined ||
          RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.rate === "" ||
          RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.rate ===
            undefined ||
          RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.min === "" ||
          RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.min ===
            undefined))
    ) {
      alert("Please enter all the details");
      return;
    }
    setTemp(
      RecuiterStore.jobPostDetails?.basicJobDetails?.jobTitle +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.workMode +
        " " +
        (Array.isArray(RecuiterStore.jobPostDetails?.basicJobDetails?.location)
          ? RecuiterStore.jobPostDetails?.basicJobDetails?.location.join(" ")
          : RecuiterStore.jobPostDetails?.basicJobDetails?.location || "") +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.openings +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.qualification +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.noticePeriod +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.experience[0] +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.experience[1] +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.parttime +
        " " +
        skills.join(" ") +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.currency +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.rate +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.min +
        " " +
        RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.max,
    );
    console.log(temp);
    const res = await RecuiterStore.autoGenerate();
    setJobDescription(res);
  };

  // alert(RecuiterStore.jobPostDetails?.basicJobDetails?.salary)

  const handleResponsibilitiesGeneration = async () => {
    if (
      RecuiterStore.jobPostDetails?.basicJobDetails?.jobTitle === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.jobTitle === undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.workMode === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.workMode === undefined ||
      // RecuiterStore.jobPostDetails?.basicJobDetails?.location === "" ||
      // RecuiterStore.jobPostDetails?.basicJobDetails?.location === undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.openings === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.openings === undefined ||
      // RecuiterStore.jobPostDetails?.basicJobDetails?.qualification === "" ||
      // RecuiterStore.jobPostDetails?.basicJobDetails?.qualification ===
      //   undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.noticePeriod === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.noticePeriod ===
        undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.experience[0] === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.experience[0] ===
        undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.experience[1] === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.experience[1] ===
        undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.parttime === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.parttime === undefined ||
      skills.length === 0 ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.currency === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.currency ===
        undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.rate === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.rate ===
        undefined ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.min === "" ||
      RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.min === undefined
    ) {
      alert("Please enter all the details");
      return;
    }
    const res = await RecuiterStore.autoGenerate(true);
    setResponsibilities(res);
  };

  // Auto Fill handler
  const handleAutoFill = () => {
    const defaults = RecuiterStore.getDefaultJobPostDetails();
    // setJobType(defaults?.jobType);
    setJobTitle(defaults.jobTitle);
    setLocation(defaults.location);
    setExperience(defaults.experience);
    setWorkMode(defaults.workMode);
    setNoOfOpenings(defaults.openings);
    setSalary(defaults.salary);
    setResumeCutoff(defaults.resumeCutoff);
    setJobDescription(defaults.jobDescription);
    setResponsibilities(defaults.responsibilities);
    setSkills(defaults.requiredSkills);
    setPartTime(defaults.parttime);
    setQualification(defaults.qualification);
    setNoticePeriod(defaults.noticePeriod);
    setRoleType(defaults.roleType);

    // Update RecuiterStore as well
    Object.entries(defaults).forEach(([key, value]) => {
      RecuiterStore.setBasicJobDetails(key, value);
    });
  };

  function decodeHTML(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  return useObserver(() => (
    <>
      <Loader text="Loading..." loader={RecuiterStore.loader} />

      <form
        onSubmit={handleSubmit}
        className="md:w-[90%] lg:w-[90%] w-[100%] mx-auto sm:mt-10 tc1:px-3 sm:px-0 tc1:mt-5 tc6:px-6 "
      >
        <h2 className="md:ml-[75px] lg:ml-[75px] text-lg font-black mt-3">
          Basic details
        </h2>
        <div className="w-[100%] mx-auto flex flex-col mt-3  justify-between md:gap-8 lg:gap-8 gap-2">
          <div className="flex w-full md:w-[90%] lg:w-[90%] md:grid md:grid-cols-3 flex-col md:mx-auto lg:mx-auto gap-x-7">
            <div className="   w-full mx-auto">
              <Input
                defaultValue={jobTitle}
                inputStyling="capitalize"
                label="Job Title"
                type="text"
                placeholder="Enter job title"
                regex={false}
                regexFormula={/^[a-zA-Z0-9]*$/}
                // value={}
                action={(e) => {
                  setDescriptionEdited(false);
                  const capitalizedValue = e.target.value
                    .split(" ")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ");
                  setJobTitle(capitalizedValue);
                  RecuiterStore.setBasicJobDetails(
                    "jobTitle",
                    capitalizedValue,
                  );
                }}
              />
            </div>
            <div className="w-full mx-auto ">
              {/* <label htmlFor="work mode" className="block text-sm font-medium text-gray-700 mb-2">work mode</label> */}

              <Select
                className=" bg-white  border absolute w-full top-20 z-10 border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto"
                label="Work Mode"
                value={workMode}
                action={(e) => {
                  setWorkMode(e.target.value);
                  setDescriptionEdited(false);
                  RecuiterStore.setBasicJobDetails("workMode", e.target.value);
                }}
                placeholder="WFH/WFO/Hybrid"
                options={[
                  { label: "Work From Home", value: "workFromHome" },
                  { label: "Work From Office", value: "workFromOffice" },
                  { label: "Hybrid", value: "hybrid" },
                  // { label: "Tele communication", value: "teleCommuncation" },
                ]}
                required={true}
              />
              {/* <CustomSelect
                label="Work Mode"
                value={workMode}
                action={(e) => {
                  setWorkMode(e.target.value);
                  setDescriptionEdited(false);
                  RecuiterStore.setBasicJobDetails("workMode", e.target.value);
                }}
                placeholder="WFH/WFO/Hybrid"
                options={[
                  { label: "Work From Home", value: "workFromHome" },
                  { label: "Work From Office", value: "workFromOffice" },
                  { label: "Hybrid", value: "hybrid" },
                ]}
                required={true}
              /> */}
            </div>
            {/* <div> */}
            {/* <div className="md:w-[40%] lg:w-[40%] w-full mx-auto">
      <Select
        label="Work Mode"
        value={workMode}
        action={(e) => {
          setWorkMode(e.target.value);
          setDescriptionEdited(false);
          RecuiterStore.setBasicJobDetails("workMode", e.target.value);
        }}
        placeholder="WFH/WFO/Hybrid"
        options={[
          { label: "Work From Home", value: "workFromHome" },
          { label: "Work From Office", value: "workFromOffice" },
          { label: "Hybrid", value: "hybrid" },
          // { label: "Tele communication", value: "teleCommuncation" },
        ]}
        required={true}
      />
    </div> */}
            {/* </div> */}

            {/* <div>
              <SelectWithDropDown/>
            </div> */}
            <div className="md:w-full lg:w-[39%] w-full mx-auto">
              <Input
                label="No.of openings"
                res={true}
                type="number"
                regex={true}
                placeholder="Enter No.of openings"
                defaultValue={noOfOpenings}
                regexFormula={/^[0-9]*$/} // Pass as RegExp, not string
                action={(e) => {
                  setDescriptionEdited(false);
                  setNoOfOpenings(e.target.value);
                  RecuiterStore.setBasicJobDetails("openings", e.target.value);
                }}
              />
              {/* <FaChevronDown className=" ml-auto w-[10px] h-[10px] -mt-6 mr-4" /> */}
            </div>
          </div>
          <div>
            <div className="flex w-full md:w-[90%] lg:w-[90%] md:flex-row lg:flex-row flex-col md:mx-auto lg:mx-auto gap-x-7">
              <div className="md:w-full mt-3 lg:mt-0 md:mt-0 lg:w-[40%] w-full mx-auto">
                <Select
                  label="Employment Type"
                  required={true}
                  placeholder="Select Employement type"
                  value={parttime}
                  action={(e) => {
                    setDescriptionEdited(false);
                    setPartTime(e.target.value);
                    RecuiterStore.setBasicJobDetails(
                      "parttime",
                      e.target.value,
                    );
                  }}
                  options={[
                    { label: "Part time", value: "part-time" },
                    { label: "Full time", value: "full-time" },
                    { label: "Freelance", value: "freelance" },
                    { label: "Remote", value: "remote" },
                    { label: "Contract-based", value: "contract-based" },
                    { label: "Commission-based", value: "commission-based" },
                    { label: "Internship", value: "internship" },
                  ]}
                />
              </div>
              <div className="md:w-full lg:w-[40%] w-full mx-auto">
                <label className="block text-sm font-medium text-gray-700 mb-2 ml-1">
                  Qualification (Optional)
                </label>
                <SearchableSelect
                  options={QUALIFICATION_OPTIONS}
                  placeholder="Search and select qualification..."
                  value={qualification}
                  onSelect={(q) => {
                    setDescriptionEdited(false);
                    setQualification(q);
                    RecuiterStore.setBasicJobDetails("qualification", q);
                  }}
                  className="h-9 text-sm"
                  grouped={true}
                />
              </div>
              <div className="w-full ">
                <Input
                  required={true}
                  label="Notice Period (in days)"
                  type="text"
                  unres="false"
                  regex={true}
                  regexFormula={/^[0-9]*$/}
                  placeholder="Enter notice period"
                  defaultValue={noticePeriod}
                  action={(e) => {
                    setDescriptionEdited(false);
                    console.log(noticePeriod);
                    setNoticePeriod(e.target.value);
                    setDescriptionEdited(false);
                    RecuiterStore.setBasicJobDetails(
                      "noticePeriod",
                      e.target.value,
                    );
                  }}
                />
              </div>
            </div>
          </div>
          <div className="flex w-full md:w-[90%] lg:w-[90%] md:grid md:grid-cols-3 gap-5 lg:flex-row flex-col   md:mx-auto lg:mx-auto gap-x-7">
            <div className="w-full">
              <Experience
                label="Required Experience (Years)"
                isResumeSorting={true}
                max={10}
                value1={
                  RecuiterStore.jobPostDetails.basicJobDetails.experience[0]
                }
                value2={
                  RecuiterStore.jobPostDetails.basicJobDetails.experience[1]
                }
                action1={(e) => {
                  setExperience([e.target.value, experience[1]]);
                  setDescriptionEdited(false);
                  RecuiterStore.setBasicJobDetails("experience", [
                    e.target.value,
                    experience[1],
                  ]);
                }}
                action2={(e) => {
                  setExperience([experience[0], e.target.value]);
                  RecuiterStore.setBasicJobDetails("experience", [
                    RecuiterStore.jobPostDetails.basicJobDetails.experience[0],
                    e.target.value,
                  ]);
                }}
              />
            </div>
            {/* <div className="w-full " ref={skillsDiv}>
              <Select
                label="Job Type"
                value={jobType}
                action={(e) => {
                  setJobType(e.target.value);
                  RecuiterStore.setBasicJobDetails("jobType", e.target.value);
                  setDescriptionEdited(false);
                  if (jobType === "job") {
                  }
                }}
                placeholder="Select job type"
                options={[
                  { label: "Job", value: "job" },
                  { label: "Internship", value: "internship" },
                ]}
                required={true}
              />
            </div> */}
            <div className="w-full ">
              <Select
                label="Role Type"
                value={roleType}
                action={(e) => {
                  setRoleType(e.target.value);
                  RecuiterStore.setBasicJobDetails("roleType", e.target.value);
                  setDescriptionEdited(false);
                }}
                placeholder="Select role type"
                options={[
                  { label: "Technical", value: "technical" },
                  { label: "Non-Technical", value: "nonTechnical" },
                ]}
                required={true}
              />
            </div>
            <div className="w-full">
              <PercentageInput
                position={window.innerWidth < 602 ? "left" : "bottom"}
                required={false}
                label=" Resume Cut off %(Optional)"
                type="number"
                regex={true}
                regexFormula={/^[0-9]*$/}
                placeholder="Enter cut-off in %"
                defaultValue={
                  RecuiterStore?.jobPostDetails?.basicJobDetails?.resumeCutoff
                }
                tooltip={`if you set the cut-off percentage,  Our Ai will do resume sorting Based on the JD, while candidates are Applying with their Resume and reject the candidates who Scored Above to your cut-off percentge(%). They will go to Next Round.`}
                action={(e) => {
                  setDescriptionEdited(false);
                  console.log(resumeCutoff);
                  setResumeCutoff([resumeCutoff, e.target.value]);
                  RecuiterStore.setBasicJobDetails(
                    "resumeCutoff",
                    e.target.value,
                  );
                }}
                setValue={setResumeCutoff}
              />
            </div>
          </div>
          <div className=" md:w-[90%] lg:w-[90%] w-full mx-auto     ">
            <div className="w-full ">
              <label className="text-lg font-sans  ">Location</label>
              <div className="space-y-3">
                {location.length > 0 && (
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    {location.map((city, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-1.5 bg-primary/10 text-primary px-3 py-1.5 rounded-full text-sm group hover:bg-primary/20 transition-colors"
                      >
                        {city}
                        <button
                          type="button"
                          onClick={() => removeaddedLocation(index)}
                          className="text-primary/50 hover:text-primary transition-colors ml-1"
                        >
                          <svg
                            className="h-3.5 w-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                    ))}
                  </div>
                )}
                <div className="w-80 mt-3">
                  <SearchableSelect
                    options={CITY_OPTIONS.filter(
                      (city) => !location.includes(city),
                    )}
                    placeholder="Search and select city..."
                    onSelect={setaddedLocation}
                    onAdd={(newCity) => {
                      if (!location.includes(newCity) && newCity !== "") {
                        setaddedLocation(newCity);
                      }
                    }}
                    className="h-9 text-sm w-80"
                    grouped={true}
                  />
                </div>
              </div>
            </div>
            {/* <FaChevronDown className="mt-12 -ml-6 w-[10px] h-[10px] " /> */}
          </div>

          {/* <div className="mb-10">
            <div className="flex w-full md:w-[90%] lg:w-[90%] md:mx-auto lg:mx-auto mb-5">
              <h2 className="text-lg font-black mt-3">Company Details</h2>
            </div>

            <div className="flex w-full md:w-[90%] lg:w-[90%] md:grid md:grid-cols-3 gap-5 lg:flex-row flex-col   md:mx-auto lg:mx-auto gap-x-7">
              <div className="w-full ">
                <Input
                  required={false}
                  label="Company Name (Optional)"
                  type="text"
                  unres="false"
                  placeholder="Enter company name"
                  defaultValue={companyName || user?.companyName}
                  action={(e) => {
                    setDescriptionEdited(false);
                    console.log(companyName);
                    setCompanyName(e.target.value);
                    setDescriptionEdited(false);
                    RecuiterStore.setBasicJobDetails(
                      "companyName",
                      e.target.value
                    );
                  }}
                />
              </div>
              <div className="w-full">
                <div className="flex flex-col gap-2 text-lg md:w-full w-[100%] tc1:mb-2 sm:mb-0">
                  <span className="flex justify-between pr-3 items-center">
                    <label className="font-sans text-base ml-3 text-[#6D6B6B]">
                      Company Logo (Optional)
                    </label>
                  </span>

                  <div className="relative">
                    {/* Add ref for file input */}
          {/* <input
                      type="file"
                      accept=".png,.jpg,.jpeg,.svg"
                      className="hidden"
                      id="companyLogoInput"
                      ref={logoInputRef}
                      onChange={async (e) => {
                        if (e.target.files && e.target.files[0]) {
                          const file = e.target.files[0];
                          setDescriptionEdited(false);
                          setLogoUploading(true);

                          try {
                            // Upload file to Azure
                            const timestamp = Date.now().toString();
                            const min = 1000;
                            const max = 9999;
                            const randomNumber =
                              Math.floor(Math.random() * (max - min + 1)) + min;
                            const filename =
                              randomNumber + timestamp + file.name;

                            const { uploadFileToAzure } = await import(
                              "../../services/azure"
                            );
                            const fileUploaded = await uploadFileToAzure(
                              filename,
                              file,
                              { action: "profile" }
                            );

                            if (fileUploaded?.url) {
                              setCompanyLogo(fileUploaded.url);
                              RecuiterStore.setBasicJobDetails(
                                "companyLogo",
                                fileUploaded.url
                              );
                              console.log("Logo uploaded:", fileUploaded.url);
                            }
                          } catch (error) {
                            console.error("Error uploading logo:", error);
                            alert("Error uploading logo. Please try again.");
                          } finally {
                            setLogoUploading(false);
                          }
                        }
                      }}
                    />

                    <div className="border px-4 rounded-lg text-base border-[#c9c9c9] h-10 flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        {logoUploading ? (
                          <span className="text-sm text-blue-600">
                            Uploading...
                          </span>
                        ) : companyLogo ? (
                          <>
                            <img
                              src={companyLogo}
                              alt="Company Logo"
                              className="w-6 h-6 object-contain rounded"
                              onError={(e) => {
                                e.target.style.display = "none";
                                e.target.nextSibling.textContent =
                                  "Logo uploaded";
                              }}
                            />
                            <span className="text-sm text-gray-600 truncate">
                              Logo uploaded
                            </span>
                          </>
                        ) : (
                          <span className="text-gray-500">
                            Click to upload company logo
                          </span>
                        )}
                      </div>

                      <div className="flex gap-2">
                        <button
                          type="button"
                          onClick={() =>
                            document.getElementById("companyLogoInput").click()
                          }
                          disabled={logoUploading}
                          className="text-primary hover:text-primary/80 transition-colors text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          {logoUploading
                            ? "Uploading..."
                            : companyLogo
                            ? "Change"
                            : "Upload"}
                        </button>
                        {companyLogo && (
                          <button
                            type="button"
                            onClick={() => {
                              setCompanyLogo("");
                              RecuiterStore.setBasicJobDetails(
                                "companyLogo",
                                ""
                              );
                              setDescriptionEdited(false);
                              if (logoInputRef.current)
                                logoInputRef.current.value = "";
                            }}
                            className="text-red-500 hover:text-red-700 transition-colors text-sm font-medium"
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full">
                <Input
                  required={false}
                  label="Company Website (Optional)"
                  type="text"
                  unres="false"
                  regex={false}
                  placeholder="Enter company website URL"
                  defaultValue={companyWebsite}
                  action={(e) => {
                    setDescriptionEdited(false);
                    console.log(companyWebsite);
                    setCompanyWebsite(e.target.value);
                    RecuiterStore.setBasicJobDetails(
                      "companyWebsite",
                      e.target.value
                    );
                  }}
                />
              </div>
            </div>

            <div className="md:w-[90%] lg:w-[90%] w-full mx-auto mt-4">
              <TextArea
                value={aboutCompany}
                label="About Company (Optional)"
                action={(e) => {
                  setAboutCompany(e.target.value);
                  setDescriptionEdited(true);
                  RecuiterStore.setBasicJobDetails(
                    "aboutCompany",
                    e.target.value
                  );
                }}
                maxLength={1000}
              />
            </div>
          </div>  */}

          {/* <div className="md:w-[90%] lg:w-[90%] w-full mx-auto" >
            <Skills
              Skills={[
                "Figma",
                "Adobe XD",
                "React JS",
                "Flutter",
                "After effects",
              ]}
              setaddedSkills={setaddedSkills}
              addedSkills={skills}
              removeSkills={removeaddedSkills}
            />
          </div> */}
          <div className="md:w-[90%] lg:w-[90%] w-full -mt-6 md:py-0 lg:py-0 md:pb-1 mx-auto md:-mt-7">
            {/* <Experience
              label="Salary(Annual package)"
              value1={RecuiterStore.jobPostDetails.basicJobDetails.salary[0]}
              value2={RecuiterStore.jobPostDetails.basicJobDetails.salary[1]}
              action1={(e) => {
                setSalary([e.target.value, salary[1]]);
                RecuiterStore.setBasicJobDetails("salary", [
                  e.target.value,
                  salary[1],
                ]);
              }}
              action2={(e) => {
                setSalary([salary[0], e.target.value]);
                RecuiterStore.setBasicJobDetails("salary", [
                  RecuiterStore.jobPostDetails.basicJobDetails.salary[0],
                  e.target.value,
                ]);
              }}
              salary={true}
            /> */}
            <Pay
              isSalaryDisclosed={
                !RecuiterStore.jobPostDetails?.basicJobDetails?.salary
                  ?.isSalaryDisclosed
              }
              setIsSalaryDisclosed={(e) => {
                RecuiterStore.setBasicJobDetails("salary", {
                  ...RecuiterStore.jobPostDetails?.basicJobDetails?.salary,
                  isSalaryDisclosed:
                    !RecuiterStore.jobPostDetails?.basicJobDetails?.salary
                      ?.isSalaryDisclosed,
                });
              }}
              showPayBy={
                RecuiterStore.jobPostDetails?.basicJobDetails?.salary.showPayBy
              }
              currency={
                RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.currency
              }
              rate={RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.rate}
              setShowPayBy={(e) => {
                RecuiterStore.setsalarydetails("showPayBy", e.target.value);
                // alert(RecuiterStore.jobPostDetails?.basicJobDetails?.salary?.showPayBy)
              }}
              setCurrency={(e) => {
                RecuiterStore.setsalarydetails("currency", e.target.value);
              }}
              setRate={(e) => {
                RecuiterStore.setsalarydetails("rate", e.target.value);
              }}
              setMinSalary={(e) => {
                RecuiterStore.setsalarydetails("min", e.target.value);
                // alert(RecuiterStore.salary.min)
              }}
              setMaxSalary={(e) => {
                RecuiterStore.setsalarydetails("max", e.target.value);
              }}
            />
          </div>
          <div className="md:w-[90%] lg:w-[90%] w-full mx-auto md:-mt-10">
            <div className="space-y-3" ref={skillsDiv}>
              <div className="flex flex-row justify-between items-center">
                <h1 className="text-lg font-sans mb-2 ">Skills Required</h1>
                <p className="text-sm text-gray-500">
                  {
                    RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills
                      .length
                  }{" "}
                  skills selected
                </p>
              </div>
              <div className="flex flex-wrap items-center gap-2 ">
                {RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills.map(
                  (skill, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-1.5 bg-primary/10 text-primary px-3 py-1.5 rounded-full text-sm group hover:bg-primary/20 transition-colors"
                    >
                      {skill}
                      <button
                        type="button"
                        onClick={() => removeaddedSkills(index)}
                        className="text-primary/50 hover:text-primary transition-colors ml-1"
                      >
                        <svg
                          className="h-3.5 w-3.5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  ),
                )}
              </div>
              <div className="w-80">
                <SearchableSelect
                  options={SKILL_OPTIONS.filter(
                    (skill) => !skills.includes(skill),
                  )}
                  placeholder="Search and select skills..."
                  onSelect={setaddedSkills}
                  className="h-9 text-sm"
                  grouped={true}
                />
              </div>
              {skills.length === 0 && (
                <div className="text-sm text-gray-500 mt-2 ">
                  <div className="flex items-center gap-2">
                    <svg
                      className="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
                      />
                    </svg>
                    <span>
                      Select skills from the dropdown to showcase your expertise
                    </span>
                  </div>
                </div>
              )}
              {/* <div className="text-xs text-gray-500">
                💡 Skills are organized by category for easy browsing. You can
                search for specific skills or browse by category.
              </div> */}
            </div>
          </div>
          <div className="md:w-[90%] lg:w-[90%] w-full mx-auto">
            <div className="flex flex-col gap-3 mb-4 text-lg">
              <label className="flex justify-between w-full">
                <span className="font-semibold ml-4">
                  Description about Job
                </span>
                <span
                  className="text-primary underline font-bold flex items-center gap-2 cursor-pointer"
                  onClick={() => {
                    setDescriptionSetting(true);
                    handleAutoGeneration();
                  }}
                >
                  <MdOutlineAutoAwesome />
                  Auto generate
                </span>
              </label>
              <div className=" rounded-2xl mb-5">
                <ReactQuill
                  theme="snow"
                  value={jobDescription}
                  onChange={(content) => {
                    setJobDescription(content);
                    setDescriptionEdited(true);
                  }}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, 4, 5, 6, false] }],
                      ["bold", "italic", "underline", "strike"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      [{ indent: "-1" }, { indent: "+1" }],
                      ["link"],
                      // ['clean']
                    ],
                  }}
                  formats={[
                    "header",
                    "bold",
                    "italic",
                    "underline",
                    "strike",
                    "list",
                    "bullet",
                    "indent",
                    "link",
                    "image",
                  ]}
                  placeholder="Enter Description here"
                  className="h-64"
                />
              </div>
            </div>
          </div>
          {/* <div className="md:w-[90%] lg:w-[90%] w-full mx-auto">
            <TextArea
              value={responsibilities}
              label="Responsibilities"
              action={(e) => {
                setResponsibilities(e.target.value);
              }}
              onClick={handleResponsibilitiesGeneration}
            />
          </div> */}
          <div className="flex md:mt-0 mt-10   justify-end w-[90%]  mx-auto  mb-20 ">
            <PrimaryButton
              buttonName={"Next"}
              width="w-fit"
              type={"submit"}
              padding={10}
              rounded="lg"
            />
          </div>
        </div>
      </form>
    </>
  ));
}
